import styled from 'styled-components';

export const QRSectionContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #eaf9ff;
  border-radius: 4px;
  margin: 0 auto 16px auto;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 4px;
    padding: 1px;
    background: linear-gradient(62.43deg, #059fff 11.73%, #0073ff 64.07%);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`;

export const QRCodeContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 4px;
  padding: 8px;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 4px;
    padding: 1px;
    background: linear-gradient(62.43deg, #059fff 11.73%, #0073ff 64.07%);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`;

export const QRSectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 8px;
`;
